import HeartSolidSVG from "@design-system/ui-icons/vanilla/HeartSolid"
import { createIcon } from "../createIcon"

export const HeartSolidIcon = createIcon(HeartSolidSVG)
